import { render, staticRenderFns } from "./paperRecord.vue?vue&type=template&id=0717e836&scoped=true"
import script from "./paperRecord.vue?vue&type=script&lang=js"
export * from "./paperRecord.vue?vue&type=script&lang=js"
import style0 from "./paperRecord.vue?vue&type=style&index=0&id=0717e836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0717e836",
  null
  
)

export default component.exports